import * as React from "react";
import type { SVGProps } from "react";
const SvgCurrencyRubel = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M8.5 19V5h6a3 3 0 0 1 0 6h-8m8 4h-8"
    />
  </svg>
);
export default SvgCurrencyRubel;
